module.exports = __webpack_public_path__ + "media/images/descendant-3dac3ba2b3333820653e44fe8444e17c.svg";